import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var PhoneComponent = (function () {
    function PhoneComponent(_data, _utils, _blogic) {
        this._data = _data;
        this._utils = _utils;
        this._blogic = _blogic;
        this.enableRecallButton = false;
        this.enableCallButton = false;
        this.enableRecallSupervisor = false;
        this.destroy$ = new Subject();
    }
    PhoneComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._updateTurn(this._data.turn);
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._updateTurn(response);
        });
        this._selectedUpdateTurn(this._data.selectedTurn);
        this._data.selectedTurnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._selectedUpdateTurn(response);
        });
    };
    PhoneComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    PhoneComponent.prototype.getTicket = function () {
        var _this = this;
        var params = {
            clientname: '',
            prekind_id: this._data.configuration['phoneKindId'],
            printed: true,
            clientid: ''
        };
        this._blogic.getTicket(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            var data = response;
            _this.callTurn(data["id"], data["queue_id"]);
        });
    };
    PhoneComponent.prototype.callTurn = function (id, queue) {
        var _this = this;
        var params = [];
        params = {
            desk_id: this._data.session["desk"],
            turn_id: id,
            queue_id: queue,
            action: this._data.configuration["actionToCall"],
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"]
        };
        this._blogic.setTurn(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            if (response["turn_id"] == "-1") {
                _this._data.closeTurn();
            }
            else {
                _this._data.turn = response;
            }
        });
    };
    /* When the turn information change */
    PhoneComponent.prototype._updateTurn = function (turn) {
        if (turn == null) {
            this.enableRecallButton = false;
        }
        else {
            this.enableRecallButton = true;
        }
    };
    /* When the turn information change */
    PhoneComponent.prototype._selectedUpdateTurn = function (selectedTurn) {
        if (selectedTurn != null && selectedTurn["type"] == 'inWait') {
            this.enableCallButton = true;
        }
        else {
            this.enableCallButton = false;
        }
        if (selectedTurn != null
            && selectedTurn["type"] == 'inAttention'
            && this._data.configuration["activeSupervisor"]) {
            this.enableRecallSupervisor = true;
        }
        else {
            this.enableRecallSupervisor = false;
        }
    };
    return PhoneComponent;
}());
export { PhoneComponent };
